import { Link, useLocation, useNavigate } from "react-router-dom";
import { Gift, LayoutDashboard, ShoppingBag, CreditCard, Home, Settings, LogOut, ShoppingCart, Users, DollarSign, Truck, Coins, Navigation, Wallet } from "lucide-react";
import { useEffect } from "react";

export const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if admin is logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('admin_logged_in');
    if (!isLoggedIn) {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_logged_in');
    navigate('/admin');
  };

  const navItems = [
    { path: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/admin/amazon/orders", icon: ShoppingCart, label: "Kòmand Amazon" },
    { path: "/admin/orders", icon: ShoppingBag, label: "Kat Kadoyo" },
    { path: "/admin/marketplace/orders", icon: ShoppingBag, label: "Kòmand Marketplace" },
    { path: "/admin/meru", icon: CreditCard, label: "Rechaj Meru" },
    { path: "/admin/crypto", icon: Coins, label: "Achte USDT" },
    { path: "/admin/wallet-requests", icon: Wallet, label: "BVGPAY Wallet" },
    { path: "/admin/dispatch", icon: Navigation, label: "Dispatcher Hub" },
    { path: "/admin/users", icon: Users, label: "Kliyan" },
    { path: "/admin/withdrawals", icon: DollarSign, label: "Demann Retrè" },
    { path: "/admin/sellers", icon: Users, label: "Machann" },
    { path: "/admin/drivers", icon: Truck, label: "Chofè Yo" },
    { path: "/admin/cards", icon: CreditCard, label: "Inventory Kat" },
    { path: "/admin/settings", icon: Settings, label: "Paramèt" },
  ];

  const isActive = (path) => {
    const currentPath = location.pathname.replace(/\/$/, "");
    const targetPath = path.replace(/\/$/, "");
    return currentPath === targetPath;
  };

  return (
    <div className="min-h-screen flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar w-64 fixed left-0 top-0 h-full text-white overflow-hidden hidden lg:flex flex-col">
        <div className="p-6 flex items-center gap-2 mb-4 border-b border-white/10">
          <div className="w-10 h-10 rounded-xl bg-[#FF9900] flex items-center justify-center flex-shrink-0">
            <Gift className="w-6 h-6 text-black" />
          </div>
          <span className="text-xl font-bold amazon-text">
            BVG<span className="text-[#FF9900]">LINK</span>
          </span>
        </div>

        <nav className="flex-1 overflow-y-auto px-4 py-4 space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive(item.path)
                ? "bg-[#FF9900] text-black font-semibold"
                : "text-gray-300 hover:bg-white/10"
                }`}
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="p-6 border-t border-white/10 space-y-3 bg-[#232F3E]">
          <Link
            to="/"
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-white/10 transition-colors"
            data-testid="admin-nav-home"
          >
            <Home className="w-5 h-5" />
            <span className="font-medium">Retounen Akèy</span>
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-red-500/20 hover:text-red-400 transition-colors w-full"
            data-testid="admin-logout"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Dekonekte</span>
          </button>
        </div>
      </aside>

      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-[#232F3E] text-white z-50 px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#FF9900] flex items-center justify-center">
              <Gift className="w-5 h-5 text-black" />
            </div>
            <span className="font-bold">Admin</span>
          </div>
          <div className="flex items-center gap-2 overflow-x-auto pb-1 max-w-[70vw]">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`p-2 rounded-lg flex-shrink-0 ${isActive(item.path) ? "bg-[#FF9900] text-black" : "text-gray-300"
                  }`}
              >
                <item.icon className="w-5 h-5" />
              </Link>
            ))}
            <Link to="/" className="p-2 rounded-lg text-gray-300">
              <Home className="w-5 h-5" />
            </Link>
            <button
              onClick={handleLogout}
              className="p-2 rounded-lg text-gray-300 hover:text-red-400"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 bg-gray-50 min-h-screen">
        <div className="p-6 lg:p-8 pt-20 lg:pt-8">
          {children}
        </div>
      </main>
    </div>
  );
};
